import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useModal } from '../../../../../hooks/use-modal';
import { PendingProviderPropType } from '../../types';
import { InviteErrorsModal } from '../invite-errors-modal';
import { InviteVendorModal } from '../invite-vendor-modal';

export const InviteModals = ({ provider, isOpenInviteModal, closeInviteModal, canResendInvite }) => {
  const [inviteErrors, setInviteErrors] = useState([]);

  const { close: onCloseErrorModal, isOpen: isErrorModalOpen, open: openErrorModal } = useModal();

  return (
    <>
      <InviteVendorModal
        canResendInvite={canResendInvite}
        closeModal={closeInviteModal}
        openModal={openErrorModal}
        provider={provider}
        setInviteErrors={setInviteErrors}
        show={isOpenInviteModal}
      />
      <InviteErrorsModal inviteErrors={inviteErrors} onClose={onCloseErrorModal} show={isErrorModalOpen} />
    </>
  );
};

InviteModals.propTypes = {
  provider: PropTypes.oneOfType([PendingProviderPropType, PropTypes.object]).isRequired,
  isOpenInviteModal: PropTypes.bool.isRequired,
  closeInviteModal: PropTypes.func.isRequired,
  canResendInvite: PropTypes.bool.isRequired,
};
